module.exports = __webpack_public_path__ + "static/media/in_a_week_2.56918b1c.jpg";